<span [@fadeInOut] class="dots">
	<span>&#183;</span><span>&#183;</span><span>&#183;</span>
</span>

